module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../node_modules/babel-loader/lib/index.js??clonedRuleSet-6!./matter.pkgd.js"));
	}, "matter.pkgd");
}